import { render, staticRenderFns } from "./ConsoleNotification.vue?vue&type=template&id=e24d94d6&scoped=true&"
import script from "./ConsoleNotification.vue?vue&type=script&lang=js&"
export * from "./ConsoleNotification.vue?vue&type=script&lang=js&"
import style0 from "./ConsoleNotification.vue?vue&type=style&index=0&id=e24d94d6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e24d94d6",
  null
  
)

export default component.exports